"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Observer {
    constructor() {
        this.listeners = [];
    }
    subscribe(listener) {
        this.listeners = [...this.listeners, listener];
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }
    publish(event) {
        this.listeners.forEach(listener => listener(event));
    }
}
exports.default = Observer;
//# sourceMappingURL=observer.js.map